export class OrganizationUserConfirmRequest {
  key: string;
}
